// Bridges ui.ts's cast handler to GameScene for a Separate·Energy cast --
// releases an existing Bind·Energy link (see energyBindEffect.ts). Bind
// creates the link, Separate undoes it, the same create/undo shape the
// operator pair already has for Momentum and Mass.
//
// The event/result shapes themselves live in rune-lab/src/sim/casts.ts with the
// handler that consumes them, and are re-exported here unchanged, so every
// import site reads them from this module -- the same shape every other
// operator effect's bridge already has.
import { UnbindEnergyEffectEvent, UnbindEnergyEffectResult } from '../../rune-lab/src/sim/casts';

export type { UnbindEnergyEffectEvent, UnbindEnergyEffectResult };

type Handler = (event: UnbindEnergyEffectEvent) => UnbindEnergyEffectResult;

let handler: Handler | null = null;

export function onUnbindEnergyEffect(fn: Handler): void {
  handler = fn;
}

export function triggerUnbindEnergyEffect(event: UnbindEnergyEffectEvent): UnbindEnergyEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '' };
}
